module.exports = __webpack_public_path__ + "assets/details-other-asset.4e7ebcec.svg";